export default __webpack_public_path__ + "static/media/right-arrow.8b8fb639.svg";